import React from 'react'
import Lottie from 'lottie-react';
import { Link } from "react-router-dom";

const SuccesMessage = ({SuccessAnimation, SucsessTitle,SucessHandleLoading,SucessHandleLoadingRedirect}) => {
  return (
    <div id='overlay'>
    <div className='load-sec'>
      <center>
        {/* Pure CSS Success Icon */}
        <div className="success-icon-load">
  <span className="check">✓</span>
</div>


        <p className='loading-tile'>{SucsessTitle}</p>

        
          <button className={`got-to-btn-show`}onClick={SucessHandleLoadingRedirect}>Go to Demo Catalague</button>
        
        <p className={`got-to-p-show`} onClick={SucessHandleLoading}>Cancel</p>
      </center>
    </div>
  </div>
  )
}

export default SuccesMessage